// src/pages/Sections.jsx (adjust path as in your project)
import React from "react";
import EducationSection from "../components/sections/Education/EducationSection";
import CertificationSection from "../components/sections/Certification/CertificationSection";
import EmploymentSection from "../components/sections/Employment/EmploymentSection";
import "./styles/Sections.css"; // can even be empty for now

const Sections = () => {
  return (
    <>
    <div className="pro-wrapper">
      <EducationSection />
    </div>
    <div className="pro-wrapper">
      <CertificationSection/>
    </div>
    <div className="pro-wrapper">
      <EmploymentSection/>
    </div>
    </>
  );
};

export default Sections;
